import { icons } from './constant';

// ==============================|| CUSTOMER MENU ITEMS ||============================== //

const customer = {
	id: 'customer_master',
	title: 'Customer',
	type: 'collapse',
	icon: icons.IconCustomer,
	children: [
		{
			id: 'qualifications',
			title: 'Qualifications',
			type: 'item',
			url: '/qualifications',
			icon: icons.IconQualification,
			breadcrumbs: true,
		},
		{
			id: 'residenceStatuses',
			title: 'Residence Types',
			type: 'item',
			url: '/residenceTypes',
			icon: icons.IconResidence,
			breadcrumbs: true,
		},
		{
			id: 'relationships',
			title: 'Relationships',
			type: 'item',
			url: '/relationships',
			icon: icons.IconRelationship,
			breadcrumbs: true,
		},
		{
			id: 'occupationTypes',
			title: 'Occupation Types',
			type: 'item',
			url: '/occupationTypes',
			icon: icons.IconOccupation,
			breadcrumbs: true,
		},
		{
			id: 'cpvFcuStatuses',
			title: 'CPV/FCU Statuses',
			type: 'item',
			url: '/cpvFcuStatuses',
			icon: icons.IconOccupation,
			breadcrumbs: true,
		},
		{
			id: 'cpv-agencies',
			title: 'CPV Agencies',
			type: 'item',
			url: '/cpvAgencies',
			icon: icons.IconOccupation,
			breadcrumbs: true,
		},
		{
			id: 'jobTypes',
			title: 'Job Types',
			type: 'item',
			url: '/jobTypes',
			icon: icons.IconOccupation,
			breadcrumbs: true,
		},
		{
			id: 'businessTypes',
			title: 'Business Types',
			type: 'item',
			url: '/businessTypes',
			icon: icons.IconOccupation,
			breadcrumbs: true,
		},
	],
};

export default customer;
